import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";

interface DeliveryColumnHeaderProps {
  title: string;
  itemCount: number;
  totalLoads: number;
  isSelectAll: boolean;
  onSelectAllChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  showCollapse?: boolean;
  onCollapse?: () => void;
  disableSelectAll?: boolean;
  highlighted?: boolean;
}

export function DeliveryColumnHeader({
  title,
  itemCount,
  totalLoads,
  isSelectAll,
  onSelectAllChange,
  showCollapse = false,
  onCollapse,
  disableSelectAll = false,
  highlighted = false,
}: DeliveryColumnHeaderProps) {
  return (
    <Box
      sx={{
        flexShrink: 0,
        mb: 1.5,
        mx: 0.5,
        mt: 0.5,
        px: 1,
        py: highlighted ? 0.75 : 0,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 1,
        borderRadius: highlighted ? "10px" : 0,
        bgcolor: highlighted ? "#f3f4f6" : "transparent",
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{
            color: highlighted ? "#374151" : "#625a57",
            lineHeight: 1.25,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: highlighted ? "#6b7280" : "#737372",
            display: "block",
            fontWeight: highlighted ? 600 : 400,
          }}
        >
          {highlighted
            ? "Drop order here"
            : `${itemCount} ${itemCount === 1 ? "order" : "orders"}${
                totalLoads > 0 ? ` · ${totalLoads} loads` : ""
              }`}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexShrink: 0, mr: 0.5 }}>
        {showCollapse && onCollapse && (
          <Box
            onClick={onCollapse}
            title={`Collapse ${title}`}
            sx={{
              width: 36,
              height: 36,
              borderRadius: "10px",
              bgcolor: "#eef7f1",
              color: "#5fa67a",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.2s ease",
              "&:hover": {
                bgcolor: "#7ec597",
                color: "#fff",
              },
            }}
          >
            <UnfoldLessIcon sx={{ fontSize: 20 }} />
          </Box>
        )}
        <Checkbox
          checked={isSelectAll}
          disabled={disableSelectAll}
          onChange={onSelectAllChange}
        />
      </Box>
    </Box>
  );
}
